module.exports = __webpack_public_path__ + "static/image/history/m/201601@3x.ver2_0_2.jpg?0f26c580";